export default __webpack_public_path__ + "static/058-b5be98577280e1e5cf48e9a5586de146.jpg";